import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const ConditionsWrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 32px;
`;

export const StyledConditionHeader = styled(FlexDiv)`
  align-items: center;
  gap: 16px;
`;

export const ConditionIconWrapper = styled(FlexDiv)`
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background-color: rgba(235, 196, 129, 0.3);
  @media only screen and (max-width: 600px) {
    height: 56px;
    width: 56px;
  }
`;

export const ConditionIcon = styled(StyledSvgSprite)`
  height: 31.42px;
  width: 30.44px;
`;

export const ConditionTitle = styled(Typography)`
  color: ${theme.colorsV2.purple.shade_800};
`;

export const SectionList = styled(FlexDiv)`
  flex-direction: column;
  gap: 32px;
`;
